import { render } from "./MetaDescriptions.vue?vue&type=template&id=3948b665&scoped=true"
import script from "./MetaDescriptions.vue?vue&type=script&lang=js"
export * from "./MetaDescriptions.vue?vue&type=script&lang=js"

import "./MetaDescriptions.vue?vue&type=style&index=0&id=3948b665&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3948b665"]])

export default __exports__